var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:( _obj = { 'header--variant' : _vm.variant }, _obj[("header--variant--" + _vm.variant)] = _vm.variant, _obj )},[_c('PageTitle',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }